import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import { useDispatch } from "react-redux";
import { setRejectModalOpen, setRejectComment } from "../../store/job/jobSlice";
import * as yup from "yup";

const RejectModal = ({ is_reject_modal_open, reject_comment, onReject }) => {
  const dispatch = useDispatch();
  const [error, setError] = useState("");

  const schema = yup.object().shape({
    comment: yup.string().trim().required("Comment is required"),
  });

  const handleOk = async () => {
    try {
      await schema.validate({ comment: reject_comment });
      onReject(reject_comment);
      dispatch(setRejectComment("")); 
      dispatch(setRejectModalOpen(false));
      setError("");
    } catch (validationError) {
      setError(validationError.message);
    }
  };

  const handleCancel = () => {
    dispatch(setRejectComment(""));
    dispatch(setRejectModalOpen(false));
    setError("");
  };

  return (
    <Dialog
      open={is_reject_modal_open}
      onClose={handleCancel}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 600, fontSize: "1.5rem" }}>
        Reject Proof
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}>
          <TextField
            label="Comment *"
            multiline
            minRows={5}
            fullWidth
            variant="outlined"
            value={reject_comment}
            onChange={(e) => dispatch(setRejectComment(e.target.value))}
            error={!!error}
            helperText={error}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          variant="outlined"
          onClick={handleCancel}
          color="error"
          sx={{ textTransform: "none", fontWeight: 500 }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleOk}
          color="primary"
          sx={{ textTransform: "none", fontWeight: 500 }}
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RejectModal;
